<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Калькулятор ИТМ
      </v-card-title>
    </v-card>

    <div class="row my-2">
      <div class="col">
        <v-card>
          <v-card-title>Данные по проекту</v-card-title>
          <v-card-text>
            <project-selector
              label="Проект"
              v-model="project"
              single />

            <v-select
              v-model="selectedPackage"
              :items="packages.items"
              item-text="title"
              item-value="_idx"
              label="Пакет"
              :loading="packages.loading"
              :disabled="!project.length || packages.loading"
              no-data-text="Пакетов не найдено"
              return-object
            />

            <div v-if="selectedPackage" class="mb-2">
              <v-chip
                v-for="(campaign, i) in selectedPackage.campaigns"
                :key="i"
                small
                class="mr-1 mb-1"
              >{{ campaign }}</v-chip>
            </div>

            <div class="row">
              <div class="col">
                <v-menu
                  v-model="menuDateStart"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="period[0]"
                      label="Дата начала"
                      prepend-icon="mdi-calendar"
                      readonly
                      :disabled="!selectedPackage"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="period[0]"
                    :min="selectedPackage && selectedPackage.started_at"
                    :max="period[1]"
                    locale="ru-RU"
                    @change="menuDateStart = false"
                  />
                </v-menu>
              </div>
              <div class="col">
                <v-menu
                  v-model="menuDateEnd"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="period[1]"
                      label="Дата окончания"
                      prepend-icon="mdi-calendar"
                      readonly
                      :disabled="!selectedPackage"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="period[1]"
                    :min="period[0]"
                    :max="packageEndDate"
                    locale="ru-RU"
                    @change="menuDateEnd = false"
                  />
                </v-menu>
              </div>
            </div>

            <v-simple-table dense>
              <tbody>
                <tr>
                  <th style="user-select: revert;">
                    Цена минуты телефонии
                  </th>
                  <td>
                    <div class="float-right">
                      <input type="text" class="input-border" v-model="payload.minuteCost">
                    </div>
                  </td>
                </tr>

                <tr>
                  <th style="user-select: revert;">
                    Админ расход
                  </th>
                  <td>
                    <div class="float-right">
                      <input type="number" class="input-border" v-model="payload.administrativeExpensesPercent">
                    </div>
                  </td>
                </tr>

                <tr>
                  <th style="user-select: revert;">
                    ФОТ операторов
                  </th>
                  <td>
                    <div class="float-right">
                      <input type="text" class="input-border" v-model="payload.operatorPayroll">
                    </div>
                  </td>
                </tr>

                <tr>
                  <th style="user-select: revert;">
                    ФОТ МП
                  </th>
                  <td>
                    <div class="float-right">
                      <input type="text" class="input-border" v-model="payload.pmPayroll">
                    </div>
                  </td>
                </tr>

                <tr>
                  <th style="user-select: revert;">
                    ФОТ РГ
                  </th>
                  <td>
                    <div class="float-right">
                      <input type="text" class="input-border" v-model="payload.glPayroll">
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <div class="mt-3">
              <v-btn color="success" @click="submit" size="small" block
              :disabled="loading || !project.length || !selectedPackage">Расчитать</v-btn>
            </div>

          </v-card-text>
        </v-card>
      </div>

      <div v-if="callsStatistics.length > 0" class="col">
        <v-card>
          <v-card-title class="border-bottom">
            Статистика звонков
          </v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <tbody>
                <tr v-for="item in callsStatistics" :key="item.label">
                  <th style="user-select: revert;">
                    <v-tooltip v-if="item.description" bottom max-width="400">
                      <template #activator="{ on }">
                        <span v-on="on">{{ item.label }}</span>
                      </template>
                      <span v-text="item.description"></span>
                    </v-tooltip>
                    <span v-else>
                      {{ item.label }}</span>
                  </th>

                  <td>
                    <div class="float-right">
                      {{ item.value }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </div>

      <div v-if="margin.length > 0" class="col">
        <v-card>
          <v-card-title>
            Маржинальность
          </v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <tbody>
                <tr v-for="item in margin" :key="item.label">
                  <th style="user-select: revert;">
                    <v-tooltip v-if="item.description" bottom max-width="400">
                      <template #activator="{ on }">
                        <span v-on="on">{{ item.label }}</span>
                      </template>
                      <span v-text="item.description"></span>
                    </v-tooltip>
                    <span v-else>
                      {{ item.label }}</span>
                  </th>
                  <td>
                    <div class="float-right">
                      <v-badge v-if="item.color && item.color !== ''"
                        :color="item.color"
                        :content="item.value"
                        inline />

                      <span v-else>{{ item.value }}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <v-row v-if="hasResults" class="mt-2">
      <v-col cols="12" class="d-flex justify-end">
        <v-btn color="primary" :loading="saving" @click="saveReport">Сохранить</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { mapActions } from 'vuex'
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue';

export default {
  name: 'Calculator',
  components: {
    ProjectSelector,
  },

  data() {
    return {
      loading: false,
      saving: false,
      loadingCounter: 2,
      lastSavePayload: null,

      project: [],
      selectedPackage: null,
      packages: {
        items: [],
        loading: false,
      },
      period: [null, null],
      menuDateStart: false,
      menuDateEnd: false,

      margin: [],
      callsStatistics: [],

      payload: {
        minuteCost: 0.0,
        administrativeExpensesPercent: 0,
        glPayroll: 0,
        pmPayroll: 0,
        operatorPayroll: 0,
      },
    }
  },

  computed: {
    packageEndDate() {
      if (!this.selectedPackage) return null;
      return this.selectedPackage.closed_at ?? new Date().toISOString().slice(0, 10);
    },

    hasResults() {
      return this.callsStatistics.length > 0 && this.margin.length > 0;
    },
  },

  watch: {
    loadingCounter(newVal) {
      if (newVal > 0) return;

      this.loadingCounter = 2;
      this.loading = false;
    },

    selectedPackage(pkg) {
      if (!pkg) {
        this.period = [null, null];
        return;
      }
      const today = new Date().toISOString().slice(0, 10);
      this.period = [pkg.started_at, pkg.closed_at ?? today];
    },

    project(newVal) {
      this.selectedPackage = null;
      this.packages.items = [];
      if (!newVal.length) return;

      this.packages.loading = true;
      this.loadProjectPackages(newVal[0])
        .then(items => {
          this.packages.items = items.map((item, idx) => ({ ...item, _idx: idx }));
        })
        .finally(() => {
          this.packages.loading = false;
        });
    },
  },

  methods: {
    ...mapActions({
      loadProjectPackages:       'otm/calculator/loadProjectPackages',
      loadPackageCallStatistics: 'otm/calculator/loadPackageCallStatistics',
      calculatePackageMargin:    'otm/calculator/calculatePackageMargin',
      saveMarginReport:          'otm/saved_margin_reports/saveReport',
    }),

    buildSavePayload() {
      const { id: packageId, contract_id: contractId, appendix_id: appendixId } = this.selectedPackage;

      return {
        contract: contractId,
        appendix: appendixId,
        package: packageId,
        period: this.period,
        minute_cost: Number(this.payload.minuteCost),
        operator_payroll: Number(this.payload.operatorPayroll),
        pm_payroll: Number(this.payload.pmPayroll),
        gl_payroll: Number(this.payload.glPayroll),
        administrative_expenses_percent: Number(this.payload.administrativeExpensesPercent),
      };
    },

    submit() {
      this.loading = true;
      this.margin = [];
      this.callsStatistics = [];
      this.lastSavePayload = null;

      const { id: packageId, contract_id: contractId, appendix_id: appendixId } = this.selectedPackage;
      this.lastSavePayload = this.buildSavePayload();

      this.calculatePackageMargin({
        contractId,
        appendixId,
        packageId,
        period: this.period,
        ...this.payload,
      }).then(items => {
        this.margin = items;
        this.loadingCounter--;
      });

      this.loadPackageCallStatistics({
        contractId,
        appendixId,
        packageId,
        period: this.period,
      }).then(items => {
        this.callsStatistics = items;
        this.loadingCounter--;
      });
    },

    async saveReport() {
      if (!this.lastSavePayload) return;

      this.saving = true;
      try {
        await this.saveMarginReport(this.lastSavePayload);
        this.$store.commit('shared/SET_SUCCESS', { message: 'Отчёт сохранён' }, { root: true });
        this.$router.push({ name: 'otm.saved-margin-reports.list' });
      } catch (err) {
        const message = (err.response && err.response.data && err.response.data.message) || 'Ошибка сохранения отчёта';
        this.$store.commit('shared/SET_ERROR', { message }, { root: true });
      } finally {
        this.saving = false;
      }
    },
  },
}
</script>

<style scoped lang="scss">
.input-border {
  text-align: right;
  width: 80px;
  padding: 0 10px;
  border-radius: 4px;
  outline: none;
  appearance: textfield;
  -moz-appearance: textfield;

  .theme--light & {
    color: rgba(0, 0, 0, 0.87);
    background: rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.24);
  }

  .theme--dark & {
    color: rgba(255, 255, 255, 0.87);
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.24);
  }
}

.input-border::-webkit-outer-spin-button,
.input-border::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

</style>
